import { Question, QuizResult } from '../types';

export const FORMAL_QUESTIONS: Question[] = [
  // ==================== 阶段一：客观现实与环境承载基准（Q01–Q10） ====================
  {
    id: 1,
    stage: 1,
    category: '日常时间配额评估',
    title: '在扣除上班、通勤、洗漱以及坐在床边发呆的时间后，你每天能匀给另一个活物的稳定精力大概是：',
    options: [
      { id: 'A', intensity: 3, label: '15 分钟以内。互相确认一眼还活着就行，再多待一会儿我就要原地融化了。', scores: { I: 2, B: 1, G: 2 } },
      { id: 'B', intensity: 2, label: '半小时左右。喂完饭、铲完屎，尽完人事后体面退场，各自回屋安好。', scores: { C: 1, M: 1 } },
      { id: 'C', intensity: 1, label: '1–2 小时。梳毛、喂食、陪玩甚至散步，哪怕今天在外面被生活虐惨了，回家也能把责任扛到底。', scores: { C: 2, M: 2, E: 1, G: -1 } },
      { id: 'D', intensity: 4, label: '它需要多久我就给多久。我可以无限压缩自己的睡眠时间——少睡两小时死不了，但它受委屈不行。', scores: { C: 2, M: 2, S: 1, G: -1 } }
    ]
  },
  {
    id: 2,
    stage: 1,
    category: '实体维持预算测定',
    title: '如果每个月的账单里，必须雷打不动多出一笔至少几百块的宠物饲养开销，你的第一反应是：',
    options: [
      { id: 'A', intensity: 1, label: '完全在掌控之中，养它之前就会单开一张卡存好至少一万块的医疗应急基金。', scores: { M: 2, G: -1 } },
      { id: 'B', intensity: 2, label: '正常吃喝拉撒尚可承受，但要是冷不丁来一次大几千的突发检查，我的心率会剧烈飙升。', scores: { M: 1 } },
      { id: 'C', intensity: 3, label: '实话实说，我目前的个人生存账单本来就处于月底吃土的边缘，再多一张嘴纯属走钢丝。', scores: { B: 1, G: 2 } },
      { id: 'D', intensity: 4, label: '现金流那是未来的事，先接回来再说，大不了一起勒紧裤腰带分吃一碗泡面。', scores: { X: 1, R: 1, G: 3 } }
    ]
  },
  {
    id: 3,
    stage: 1,
    category: '空间参数与承载上限',
    title: '你目前住所的空间条件以及对另一个生命体的容纳权限，更符合哪种现状：',
    options: [
      { id: 'A', intensity: 1, label: '面积宽敞，光照通风良好，自己说了算，哪怕它在客厅原地打滚也毫无压力。', scores: { P: 2, G: -1 } },
      { id: 'B', intensity: 2, label: '标准一居或两居，容纳一只中小型动物溜达完全足够，家具布局也能做适度调整。', scores: { P: 1 } },
      { id: 'C', intensity: 3, label: '空间紧凑甚至是合租单间，但靠着极致的收纳和断舍离，能强行给它腾出一块领地。', scores: { M: 1, P: -1 } },
      { id: 'D', intensity: 4, label: '房东、家人或室友已经明确挂出红牌警告，或者我自己近半年内随时可能打包行李搬家。', scores: { R: 1, G: 3 } }
    ]
  },
  {
    id: 4,
    stage: 1,
    category: '生物钟稳定性评估',
    title: '你日常的作息轨迹和生活生物钟，通常呈现出何种运转状态：',
    options: [
      { id: 'A', intensity: 1, label: '规律得像一台出厂校准过的钟表，几点起、几点睡，基本不会脱轨。', scores: { M: 2, B: -2, G: -1 } },
      { id: 'B', intensity: 2, label: '大体稳定，偶尔熬个夜刷刷手机，但一两天内就能自己把时差倒回来。', scores: { M: 1, G: -1 } },
      { id: 'C', intensity: 3, label: '随机漂移模式，完全取决于工作催得多凶、客户改得多次、以及半夜何时突然来灵感。', scores: { X: 1, B: 1, G: 1 } },
      { id: 'D', intensity: 4, label: '极其魔幻，我自己都无法预测明天到底是会被早晨的阳光叫醒，还是干脆直接从下午吃第一餐。', scores: { X: 2, B: 2, G: 2 } }
    ]
  },
  {
    id: 5,
    stage: 1,
    category: '环境污染与突发耐受',
    title: '推开家门，发现地板正中央赫然出现一小滩成分不明的微温液体，你的本能反应是：',
    options: [
      { id: 'A', intensity: 1, label: '叹口气，立刻戴上手套拿起消毒喷雾彻底清理，并顺藤摸瓜排查到底是哪里漏了。', scores: { M: 2, S: 1 } },
      { id: 'B', intensity: 2, label: '扯大半卷厨房纸先盖上去踩两脚吸干，至于善后和拖地，等我坐下歇口气再说。', scores: { M: 1 } },
      { id: 'C', intensity: 3, label: '默默跨过去假装没看见，必须在沙发上躺够半小时积攒足了心理能量再去面对。', scores: { B: 1, G: 1 } },
      { id: 'D', intensity: 4, label: '只要它没有以肉眼可见的速度向四周持续蔓延，大家暂且维持表面和平共存。', scores: { B: 2, X: 1, G: 2 } }
    ]
  },
  {
    id: 6,
    stage: 1,
    category: '空间禁闭应激反应',
    title: '如果连续三天因为极端暴雨无法踏出大门，你的精神状态通常会走向：',
    options: [
      { id: 'A', intensity: 3, label: '极其暴躁，在客厅来回踱步，感觉骨头缝里都在长蘑菇，必须套上雨衣出去狂走一万步。', scores: { E: 2 } },
      { id: 'B', intensity: 1, label: '开窗透透气还行，虽然有点闷，但整体还在忍受范围内，能坐得住。', scores: { E: 1 } },
      { id: 'C', intensity: 2, label: '毫无波动，甚至暗自狂喜：外面的风雨越大，我越觉得家里这张床才是世界唯一的避难所。', scores: { I: 1, B: 1, E: -1 } },
      { id: 'D', intensity: 4, label: '极其安详，整个人已经跟床垫发生物理熔接，要是外卖能从门缝直接压扁滑进来就更完美了。', scores: { B: 2, A: 1, E: -2 } }
    ]
  },
  {
    id: 7,
    stage: 1,
    category: '听觉神经敏感阈值',
    title: '如果屋子里长期伴随某种轻微但持续的细碎动静（比如爪子抓地声、喝水声或咕噜声）：',
    options: [
      { id: 'A', intensity: 2, label: '挺好的，就喜欢这种屋子里有另一个活物在喘气的声响，很有生活气。', scores: { V: 2, C: 1 } },
      { id: 'B', intensity: 1, label: '只要不是半夜突然暴起尖叫或狂吠，大脑会自动把这些动静归类为白噪音。', scores: { V: 1 } },
      { id: 'C', intensity: 3, label: '偏好绝对安静，注意力容易被打散，任何不规律的细小响动听久了都让我神经紧绷。', scores: { I: 1, V: -1 } },
      { id: 'D', intensity: 4, label: '极度神经衰弱，连半夜冰箱压缩机突然启动哼哼两声，我都觉得它是在故意找我麻烦。', scores: { S: 2, V: -2, A: 1 } }
    ]
  },
  {
    id: 8,
    stage: 1,
    category: '高频重复性劳动耐力',
    title: '面对“每天早晚必须在固定时间点重复完成喂饭、添水、铲屎/擦笼子”，你的耐力极限是：',
    options: [
      { id: 'A', intensity: 1, label: '毫无压力，早就内化成不需要动脑子的肌肉记忆，跟每天刷牙洗脸一样自然。', scores: { M: 2, B: -2, G: -1 } },
      { id: 'B', intensity: 2, label: '能够维持，前提是整个操作步骤别太反人类，最好五分钟内能麻利搞定。', scores: { M: 1 } },
      { id: 'C', intensity: 3, label: '极度想当好模范饲养员，但只要碰上连轴转加班，就不可避免地出现断片和记忆遗漏。', scores: { S: 1, G: 1 } },
      { id: 'D', intensity: 4, label: '坚持三天之后，大概率会反向演变成靠它跳上床猛扒我被子才能把我叫醒。', scores: { A: 1, B: 2, G: 2 } }
    ]
  },
  {
    id: 9,
    stage: 1,
    category: '急性故障与损耗处置',
    title: '深夜两点半，它突然突发急性状况，需要你立刻从被窝爬起来打车去二十公里外的 24 小时急诊：',
    options: [
      { id: 'A', intensity: 1, label: '毫无怨言，抱起它就冲下楼，在养它的第一天我就把这笔突发成本和精力算进去了。', scores: { M: 2, C: 1, G: -1 } },
      { id: 'B', intensity: 2, label: '钱包和精神都在滴血，但身体会强撑着按医疗流程把所有检查老老实实做完。', scores: { M: 1, S: 1 } },
      { id: 'C', intensity: 3, label: '当场陷入剧烈的情绪过载和不知所措，手忙脚乱在原地团团转，急得只想掉眼泪。', scores: { S: 2, G: 1 } },
      { id: 'D', intensity: 4, label: '脑内冒出的第一个荒唐念头：能不能先长按它肚子 10 秒尝试看看能不能强制重启？', scores: { A: 2, B: 1, G: 2 } }
    ]
  },
  {
    id: 10,
    stage: 1,
    category: '长期关系存续测定',
    title: '面对一段长达 10 到 15 年、不可随意中途弃单的生命契约，你内心深处的声音更接近：',
    options: [
      { id: 'A', intensity: 1, label: '既然决定把它带回家，就做好了一路陪它走到生老病死终点的全部准备。', scores: { M: 2, B: -2, G: -1 } },
      { id: 'B', intensity: 2, label: '心存敬畏，希望能顺顺利利，但偶尔也会担心未来换城市或变故会不会辜负它。', scores: { I: 1, M: 1 } },
      { id: 'C', intensity: 3, label: '坦白讲，我甚至无法百分之百确信自己下周二晚上会在哪座城市吃晚饭。', scores: { B: 1, G: 1 } },
      { id: 'D', intensity: 4, label: '回顾我过往的人生履历，我所有的长期爱好，最大的共同点就是它们都曾是我的爱好。', scores: { A: 1, B: 2, G: 2 } }
    ]
  },

  // ==================== 阶段二：性格特质与生活方式渗入（Q11–Q20） ====================
  {
    id: 11,
    stage: 2,
    category: '休战期能源补给形态',
    title: '熬完一整周的牛马生活，面对仅有的 48 小时周末，你最本能的电量抢救方案是：',
    systemNote: '系统提示：注意观察受试者自律参数与能量流向',
    options: [
      { id: 'A', intensity: 2, label: '背上包扎进山里徒步或者去球场，用一身透汗把脑子里积攒的废气彻底冲刷掉。', scores: { E: 2, N: 1 } },
      { id: 'B', intensity: 1, label: '喊上两三个真正交心的老朋友吃顿热饭，把胸口憋着的牢骚一股脑倒干净。', scores: { C: 2 } },
      { id: 'C', intensity: 3, label: '戴上降噪耳机，开一罐冰饮料，沉浸式打单机或看部好电影，在完全不需要应付任何人的世界里自得其乐。', scores: { I: 2 } },
      { id: 'D', intensity: 4, label: '以一种扭曲但符合人体工学的姿势在床上持续融化，像一滩无机物一样静静等待周一从天而降。', scores: { B: 2, A: 1 } }
    ]
  },
  {
    id: 12,
    stage: 2,
    category: '伴生实体引力场偏好',
    title: '在同一个屋檐下，你更偏好与它保持怎样的物理引力距离：',
    options: [
      { id: 'A', intensity: 2, label: '高浓度强力胶模式。最好我走到哪跟到哪，坐下压膝盖、躺下贴后背，视线盲区绝不能超过五秒。', scores: { C: 2, I: -1 } },
      { id: 'B', intensity: 1, label: '薛定谔的互动。各自电量充足时猛烈贴贴，其余时间在各自的领地里散步闲逛。', scores: { C: 1, I: 1 } },
      { id: 'C', intensity: 3, label: '绝对的平行轨道。处在同一个房间内相安无事，但请保持一米以上的安全礼貌车距。', scores: { I: 2 } },
      { id: 'D', intensity: 4, label: '只要每隔 48 小时隔空对视一眼，确认彼此尚有微弱的生命体征，就可以继续互不干扰。', scores: { I: 2, A: 1 } }
    ]
  },
  {
    id: 13,
    stage: 2,
    category: '突发外部指令应答',
    title: '深夜 23:15，手机突然弹出一条消息：“出来吃夜宵！车已经到你楼下了，立刻下楼！”你的第一反应是：',
    options: [
      { id: 'A', intensity: 1, label: '坚决驳回。任何未经提前 24 小时报备的突击日程，都会瞬间击穿我的心理防御工事。', scores: { S: 1, X: -2 } },
      { id: 'B', intensity: 2, label: '在脑内迅速盘算几点能撤退回家、明早要补几杯美式，权衡之后再决定要不要换衣服。', scores: { M: 1, X: -1 } },
      { id: 'C', intensity: 3, label: '神经一阵轻微发麻，整个人在大脑想去浪和身体好特么累之间疯狂来回拉扯。', scores: { N: 1, X: 1 } },
      { id: 'D', intensity: 4, label: '脑子甚至还没完全理解这条消息，肉体已经在副驾驶把安全带咔哒一声扣上了。', scores: { E: 1, N: 2, X: 2 } }
    ]
  },
  {
    id: 14,
    stage: 2,
    category: '高敏感易碎体共情承载',
    title: '面对一个神经极度脆弱敏感、稍有风吹草动就吓得缩进角落抖成筛子的易碎生命：',
    systemNote: '系统提示：心率耐受与同理心带宽测定中',
    options: [
      { id: 'A', intensity: 2, label: '自动切换静音潜行模式，把动作放慢十倍，用极高的耐心在几个月里慢慢重建它的安全感。', scores: { S: 2, M: 2 } },
      { id: 'B', intensity: 1, label: '愿意悉心照料，但在接回来之前必须翻遍专业论坛和饲养手册，把坑摸透了才敢上手。', scores: { S: 1, M: 1 } },
      { id: 'C', intensity: 3, label: '心理压力巨大，每天战战兢兢，生怕自己关门稍微大点声就把它当场吓出毛病。', scores: { S: 2, G: 1 } },
      { id: 'D', intensity: 4, label: '心生绝望：在这个屋檐底下，我们俩至少得有一个人的精神状态能保持相对稳定吧？', scores: { A: 1, X: 1 } }
    ]
  },
  {
    id: 15,
    stage: 2,
    category: '高智商实体博弈承受力',
    title: '如果它拥有极高智商，每天变着花样拆解家具、破解门锁，需要你持续跟它斗智斗勇：',
    options: [
      { id: 'A', intensity: 2, label: '极具征服欲！我就喜欢这种棋逢对手的高智商博弈，天天琢磨新谜题给它解。', scores: { E: 2, M: 2, N: 1 } },
      { id: 'B', intensity: 1, label: '挺有意思的，闲着的时候陪它玩玩套路，权当是生活里一种温和的脑力拉伸。', scores: { C: 1, M: 1 } },
      { id: 'C', intensity: 3, label: '算了吧，我上一整天班脑细胞早就阵亡殆尽了，回家只想抱着不带脑子的傻白甜放空。', scores: { I: 1, M: -1 } },
      { id: 'D', intensity: 4, label: '拆家我都可以忍，前提是它别当着我的面，把对我智商的鄙视表现得过于露骨。', scores: { A: 2, B: 1 } }
    ]
  },
  {
    id: 16,
    stage: 2,
    category: '室内实体统治力耐受',
    title: '对于“家里存在一个极度显眼、一刻不停在刷存在感的显眼包”，你的心理接纳度是：',
    options: [
      { id: 'A', intensity: 2, label: '举双手欢迎！最好天天在客厅自编自导八集大型连续剧，把家里折腾得热气腾腾。', scores: { V: 2, C: 1, X: 1 } },
      { id: 'B', intensity: 1, label: '适度吵闹挺好的，至少能证明我住的不是一处无人问津的赛博废墟。', scores: { V: 1 } },
      { id: 'C', intensity: 3, label: '严禁喧宾夺主，我需要它大部分时间保持低调、内敛，甚至最好学会原地隐身。', scores: { I: 1, V: -1 } },
      { id: 'D', intensity: 4, label: '显眼可以，但必须坐下来签一份备忘录：严禁篡夺这个家真正的最高话事权。', scores: { V: 1, R: 1, A: 1 } }
    ]
  },
  {
    id: 17,
    stage: 2,
    category: '非主流生化形态兼容',
    title: '如果在宠物展或朋友家，撞见一只长相极其怪异但合法饲养的冷血/节肢类异宠：',
    options: [
      { id: 'A', intensity: 3, label: '生理性后退两步，头皮发麻，虽然知道它没毒，但身体本能已经准备报警了。', scores: { S: 1, N: -2 } },
      { id: 'B', intensity: 1, label: '隔着玻璃箱客气地看两眼就行，没有任何想把它领回自己卧室的世俗欲望。', scores: { N: -1 } },
      { id: 'C', intensity: 2, label: '两眼放光立刻凑上去，顺便把它的温控箱、造景垫材和食谱查个底朝天。', scores: { N: 2, M: 1 } },
      { id: 'D', intensity: 4, label: '审美雷达瞬间狂响：越是长得不像地球正经毛孩子的生物，我越觉得它眉清目秀、一身仙气。', scores: { N: 2, A: 1, R: 1 } }
    ]
  },
  {
    id: 18,
    stage: 2,
    category: '训导耐力与主客体逆转',
    title: '为了让它学会不在沙发乱尿，你需要把同一个纠偏动作雷打不动重复教上几十遍：',
    options: [
      { id: 'A', intensity: 1, label: '严格遵循行为学原理，不打不骂，定时定点正向奖励，主打一个情绪稳定的长期抗战。', scores: { M: 2, S: 1 } },
      { id: 'B', intensity: 2, label: '极限耐受大概在十次左右，超出这个底线我的太阳穴就会开始突突狂跳。', scores: { M: 1 } },
      { id: 'C', intensity: 3, label: '耐心光速告罄，擦着地板甚至开始深刻反思这项训练对浩瀚宇宙到底有什么屁用。', scores: { X: 1, M: -1 } },
      { id: 'D', intensity: 4, label: '按照历史经验推演，最后大概率会演变成它成功掌握规律，反向把我训练成了巴甫洛夫。', scores: { A: 2, X: 1 } }
    ]
  },
  {
    id: 19,
    stage: 2,
    category: '倒错生物节律兼容度',
    title: '如果它白天全程昏睡对你爱搭不理，一到凌晨两点半突然在客厅走廊疯狂跑酷：',
    options: [
      { id: 'A', intensity: 3, label: '完全无法忍受，这是对人类正常生理作息的恶劣践踏和公然挑衅。', scores: { C: 1, N: -1 } },
      { id: 'B', intensity: 1, label: '略感崩溃，必须物理隔断，睡觉前把卧室门反锁，任由它在外面折腾。', scores: { S: 1 } },
      { id: 'C', intensity: 2, label: '只要爪子别直接拍在我的眼皮上，爱怎么狂欢随它去，我的睡意坚如磐石。', scores: { I: 1, N: 1 } },
      { id: 'D', intensity: 4, label: '甚至有点欣慰：很好，这间屋子终于有一位合法家庭成员负责通宵值夜班了。', scores: { A: 2, N: 2 } }
    ]
  },
  {
    id: 20,
    stage: 2,
    category: '情感反馈解码习惯',
    title: '在建立深层情感连结时，你更适应对方采用哪种情绪反馈模式：',
    options: [
      { id: 'A', intensity: 2, label: '情绪极其饱满外溢，高兴了尾巴摇成直升机，难过了哼哼唧唧，毫无保留。', scores: { C: 2, V: 1 } },
      { id: 'B', intensity: 1, label: '温和克制如溪水，每天都处于可预测的标准水平，不作妖也不过分狂热。', scores: { S: 1, M: 1 } },
      { id: 'C', intensity: 3, label: '孤高独立守边疆，哪怕心里再在乎你，表面上也依然保持拽哥/拽姐的扑克脸。', scores: { I: 2 } },
      { id: 'D', intensity: 4, label: '无论它到底有没有灵魂，只求别整那些让我死几万个脑细胞猜谜的弯弯绕。', scores: { I: 2, S: -1, A: 1 } }
    ]
  },

  // ==================== 阶段三：荒诞场景与解构加速（Q21–Q28） ====================
  {
    id: 21,
    stage: 3,
    category: '空白区域凝视异常',
    title: '某天傍晚，它突然正襟危坐，对着一面毫无杂质的空白白墙死死凝视了整整十分钟：',
    systemNote: '【异常记录：观察到环境场存在轻度非对称畸变】',
    options: [
      { id: 'A', intensity: 1, label: '凑过去拿手指敲敲墙面，排查是否有水管微渗、虫蚁穿行或墙体轻微空鼓。', scores: { S: 1, X: -1 } },
      { id: 'B', intensity: 2, label: '把它强行抱开塞一把零食，试图通过物理位移打断它这种神叨叨的聚焦。', scores: { C: 1, M: 1 } },
      { id: 'C', intensity: 3, label: '摸出手机迅速发帖提问：“宠物突然对着空白墙壁发呆到底是在看什么？”', scores: { M: 1, N: 1 } },
      { id: 'D', intensity: 4, label: '默默走过去坐到它旁边，跟它保持完全一致的角度，一起向虚无致意。', scores: { X: 2, A: 2 } }
    ]
  },
  {
    id: 22,
    stage: 3,
    category: '凌晨未知声学撞击',
    title: '凌晨 03:17，死寂的客厅突然毫无征兆地爆出一记沉闷的重响：“咚！”',
    options: [
      { id: 'A', intensity: 2, label: '神经瞬间拉响一级战备，抄起手边最沉的家伙，猫着腰去客厅把所有门后和柜底排查一遍。', scores: { S: 2, M: 1 } },
      { id: 'B', intensity: 1, label: '按开床头灯，屏住呼吸在黑暗里死死竖起耳朵，试图用排除法分析到底是什么东西掉下来了。', scores: { S: 1 } },
      { id: 'C', intensity: 3, label: '默默把被子拉过头顶死死掖好——只要眼睛闭得足够用力，现实世界发生的任何事就伤不到我。', scores: { B: 1, X: 1 } },
      { id: 'D', intensity: 4, label: '翻了个身，清了清嗓子，用更沉稳洪亮的中气对着黑黢黢的客厅也回敬了一声：“咚！”', scores: { X: 2, A: 2, R: 1 } }
    ]
  },
  {
    id: 23,
    stage: 3,
    category: '跨物种语义突变',
    title: '某天深夜它突然直立端坐，字正腔圆地用标准普通话对你吐露人言：“其实这一切我全都知道。”',
    systemNote: '【警告：正在跨越常规语义通信协议】',
    options: [
      { id: 'A', intensity: 1, label: '猛掐人中并在脑内飞速确认：我是不是又陷入了深层缺氧引发的多重清醒梦？', scores: { S: 1, X: -1 } },
      { id: 'B', intensity: 2, label: '瞬间进入科研战备状态，悄悄点开手机高清录像并同步开启多端云备份。', scores: { N: 1, V: 1 } },
      { id: 'C', intensity: 3, label: '呼吸急促，试探性咽了口唾沫低声交涉：“等等……你具体都知道了些什么？”', scores: { C: 1, N: 2 } },
      { id: 'D', intensity: 4, label: '冷笑一声拉开椅子坐到它对面：“怎么，装了这么多年傻子，今天终于装不下去了？”', scores: { X: 2, A: 2, R: 1 } }
    ]
  },
  {
    id: 24,
    stage: 3,
    category: '常规收容被拒悖论',
    title: '如果本测试中央算法明确通知你：“基于综合评定，严正建议你放弃饲养任何常规地球生物。”',
    options: [
      { id: 'A', intensity: 1, label: '遵从权威判定，收回冲动，老老实实回去过我平平无奇的单机人类生活。', scores: { M: 1, R: -2 } },
      { id: 'B', intensity: 2, label: '调取后台运算日志，非要死磕明白我到底是哪项人格参数被判定为不合格。', scores: { N: 1 } },
      { id: 'C', intensity: 3, label: '逆反心理骤起：你们越是不批，我今天越要看看到底能给我整出个什么奇行种。', scores: { R: 2, N: 1 } },
      { id: 'D', intensity: 4, label: '精神大振：太好了！无聊的碳基物种终于落幕了，快把非法收容物给我端上来！', scores: { R: 2, A: 2, N: 2 } }
    ]
  },
  {
    id: 25,
    stage: 3,
    category: '不可名状贡品呈递',
    title: '它迈着极其庄重的步伐走过来，将一件你无论如何也辨认不出材质与用途的诡异物体放在你膝盖上：',
    options: [
      { id: 'A', intensity: 1, label: '戴上一次性手套火速收缴隔离，防范任何可能的病菌、毒素或吞咽窒息隐患。', scores: { M: 2, X: -1 } },
      { id: 'B', intensity: 2, label: '移到台灯底下，拿起放大镜细细端详，试图搞清楚它的微观构造和来源轨迹。', scores: { N: 2 } },
      { id: 'C', intensity: 3, label: '拍高清近景九宫格发群里：“家人们速看，我家这位今天出门给爆出隐藏神装了。”', scores: { V: 1, A: 1 } },
      { id: 'D', intensity: 4, label: '肃穆地单膝微屈郑重接下，并坚定认为这属于某种古老祭祀仪式的信物交接。', scores: { A: 2, X: 2 } }
    ]
  },
  {
    id: 26,
    stage: 3,
    category: '固定时间点位威慑',
    title: '每天傍晚 18:00 整，它总会准时蹲守在玄关门后，用毫无波澜的眼神将你上下扫视一遍，你的理解是：',
    systemNote: '【系统提示：家庭层级统治模型发生漂移】',
    options: [
      { id: 'A', intensity: 1, label: '生物钟条件反射，此时代表放饭、换水或外出排泄的刚性生理信号触发了。', scores: { M: 2, S: 1 } },
      { id: 'B', intensity: 2, label: '它在以自己特有的笨拙方式期盼我的归巢，这是生命之间无言的忠诚守望。', scores: { C: 2 } },
      { id: 'C', intensity: 3, label: '感到后颈发凉，总怀疑它其实是暗中观察我的考勤数据，准备向神秘上级打小报告。', scores: { S: 2 } },
      { id: 'D', intensity: 4, label: '无须怀疑，它就是这间屋子的实质考勤主管，今天我又因迟到了三分之二秒被扣分。', scores: { A: 2, V: 1 } }
    ]
  },
  {
    id: 27,
    stage: 3,
    category: '既定秩序全面崩塌',
    title: '当你精心筹划的安排被突发事件一记重拳砸得稀碎、所有事情都在失控滑轨时：',
    options: [
      { id: 'A', intensity: 2, label: '深吸一口气压住血压，立刻打开备忘录重新列出 Plan B，在废墟上继续把进度抢救回来。', scores: { M: 2, X: -2 } },
      { id: 'B', intensity: 1, label: '先停下手头所有动作，迅速砍掉不重要的细枝末节，集中火力只保住最核心的一两件事。', scores: { M: 1 } },
      { id: 'C', intensity: 3, label: '直接双臂自然下垂：今天这颗星球就先转到这吧，剩下的烂摊子等我活过今晚再说。', scores: { B: 2, X: 1 } },
      { id: 'D', intensity: 4, label: '内心甚至冒出一丝扭曲的轻松：既然这破车彻底脱轨了，不如让我看看它最后能飞到哪去。', scores: { X: 2, A: 2, R: 1 } }
    ]
  },
  {
    id: 28,
    stage: 3,
    category: '超现实解构抗体测定',
    title: '在网络上目睹成千上万的网民为一个毫无逻辑、荒腔走板的魔性无厘头符号疯狂狂欢时：',
    options: [
      { id: 'A', intensity: 2, label: '眉头紧锁，对现代人类注意力资源被严重低幼化收割感到深深的悲哀。', scores: { A: -2 } },
      { id: 'B', intensity: 1, label: '能理解大家压力大想宣泄，但自己冷眼旁观，绝不会浪费宝贵的时间去掺和。', scores: { A: -1 } },
      { id: 'C', intensity: 3, label: '极易被精神传染，点进去看了不到三秒嘴角就失守，并开始跟着傻乐呵。', scores: { A: 1, V: 1 } },
      { id: 'D', intensity: 4, label: '神经突触瞬间接管肉体，十分钟后我自己剪辑的魔性二创切片已经在群里屠榜了。', scores: { A: 2, X: 1, R: 1 } }
    ]
  },

  // ==================== 阶段四：后七题系统失控与终极裁定（Q29–Q35） ====================
  {
    id: 29,
    stage: 4,
    category: '非法实体突击降临',
    title: '疲惫推开门，客厅正中央赫然盘踞着一个体积肥硕、通体明黄、完全不归你所有的未知生物：',
    systemNote: '【红色越权报警：检测到高维黄色未认证实体侵入】',
    options: [
      { id: 'A', intensity: 1, label: '战术后撤反手把门扣死，立刻调取楼道监控查验它到底是顺着哪条管道爬进来的。', scores: { M: 2, X: -1 } },
      { id: 'B', intensity: 2, label: '保持五米安全测距，顺手抄起墙角的扫把横在身前，保持防御姿态冷眼观察。', scores: { I: 1, N: 1 } },
      { id: 'C', intensity: 3, label: '迅速掏出手机抓拍留证发小红书：“在线求助，家里突然刷新了一坨黄色胖子算入室抢劫吗？”', scores: { N: 1, V: 1, A: 1 } },
      { id: 'D', intensity: 4, label: '叹了口气反手把门锁好：“来都来了，算你一份公摊房租，自己找个垫子趴好。”', scores: { C: 2, X: 2, A: 2 } }
    ]
  },
  {
    id: 30,
    stage: 4,
    category: '无言审判与精神反攻',
    title: '它发不出人类的声音，但投射过来的眼神中，分明写满了对你整个人生意义的刻薄批注：',
    options: [
      { id: 'A', intensity: 1, label: '严正拒绝被非认证生物评判，试图通过拍手厉声喝止来恢复一家之主的尊严。', scores: { R: -1, X: -1 } },
      { id: 'B', intensity: 3, label: '如芒在背浑身刺挠，开始在心里暗自反省自己今天是不是又虚度光阴摸了一整天鱼。', scores: { S: 1 } },
      { id: 'C', intensity: 2, label: '试图建立友好外交，拆开一根冻干肉条递上去，想弄明白在高维生物眼里我到底算个啥。', scores: { C: 1, N: 1 } },
      { id: 'D', intensity: 4, label: '双臂抱胸当场恶狠狠瞪回去，在脑内对其五短身材与智力发育展开三百六十度刻薄反攻。', scores: { R: 2, X: 1, A: 2 } }
    ]
  },
  {
    id: 31,
    stage: 4,
    category: '系统深红级越权警报',
    title: '测试界面突然跳出一道刺眼的红色警告：“警告：继续作答将导致匹配结果彻底脱离地球已知生物纲目！”',
    systemNote: '【CRITICAL HAZARD // 碳基生物谱系数据库全面崩溃】',
    options: [
      { id: 'A', intensity: 1, label: '火速寻找「退出测试」按钮——人活一世不容易，我还是老老实实回安全区当个正常人类吧。', scores: { M: 1, X: -2, R: -1 } },
      { id: 'B', intensity: 2, label: '后背隐隐发凉，但在巨大的好奇心驱使下，还是咬着牙按下了「无视风险，继续作答」。', scores: { N: 1 } },
      { id: 'C', intensity: 3, label: '面无表情地随手叉掉弹窗并翻了个白眼：少吓唬人，把下一题给我端上来。', scores: { R: 1, A: 1 } },
      { id: 'D', intensity: 4, label: '精神瞬间支棱起来：废话！我辛辛苦苦答了 30 道题，不就是为了看你们系统怎么崩溃吗？', scores: { R: 2, A: 2, X: 2 } }
    ]
  },
  {
    id: 32,
    stage: 4,
    category: '群体性罢工共谋',
    title: '某个暴雨狂风的清晨，它用屁股死死卡住大门，全身每根骨头都在表示“今天谁也别想出门”：',
    options: [
      { id: 'A', intensity: 1, label: '严格按照规矩办事，扣上牵引绳进行纪律规训，该执行的日常流程一项也不能少。', scores: { M: 2, R: -1 } },
      { id: 'B', intensity: 2, label: '妥协微调，把室外高耗能活动压缩成室内简易消耗方案，各退一步海阔天空。', scores: { S: 1, X: 1 } },
      { id: 'C', intensity: 3, label: '如释重负地松了一大口气，顺水推舟把闹钟彻底拍死：既然你都不动，那我也不动了。', scores: { B: 2 } },
      { id: 'D', intensity: 4, label: '当场踢飞公文包倒头同躺：达成共谋！从现在起今天谁要是敢迈出这道门谁就是狗。', scores: { B: 2, X: 2, R: 2 } }
    ]
  },
  {
    id: 33,
    stage: 4,
    category: '荒谬厄运解构本能',
    title: '当你接二连三遭遇了一整套不可理喻、甚至充满某种地狱笑话色彩的极端倒霉事件时：',
    options: [
      { id: 'A', intensity: 1, label: '拉出复盘看板，冷静排查每一个漏洞与变量，杜绝类似连锁翻车再次重演。', scores: { M: 2, X: -2 } },
      { id: 'B', intensity: 2, label: '陷入长达两小时的生理性自闭，整个人瘫在沙发上一言不发，等情绪退潮再慢慢收拾残局。', scores: { S: 1 } },
      { id: 'C', intensity: 3, label: '启动终极休眠协议，坚信只要我先在被窝里睡成一具干尸，厄运就失去了攻击实体。', scores: { B: 2 } },
      { id: 'D', intensity: 4, label: '嘴角逐渐浮现出一抹诡异的冷笑，立刻点开备忘录：“绝了，这地狱笑话素材简直千载难逢。”', scores: { A: 2, X: 1, R: 1 } }
    ]
  },
  {
    id: 34,
    stage: 4,
    category: '现实说明书破损悖论',
    title: '命运的裂缝中突然掉落一本泛黄发脆的《现实世界维生说明书》，但通篇皆为不可名状的奇怪符号：',
    systemNote: '【解密失败：符号学矩阵已被未知高维逻辑污染】',
    options: [
      { id: 'A', intensity: 1, label: '判定为无资质的野鸡出版物，立刻去正规官方渠道检索权威标准的保姆级教程。', scores: { M: 2, N: -1 } },
      { id: 'B', intensity: 2, label: '结合上下文的鬼画符半猜半蒙，小心翼翼开展局部小规模低危肉体试错。', scores: { N: 1, X: 1 } },
      { id: 'C', intensity: 3, label: '随手将说明书扔进垃圾桶：真正的硬汉从来不看说明书，直接生拔硬拽大力出奇迹。', scores: { R: 2, X: 1 } },
      { id: 'D', intensity: 4, label: '先翻到最后一页版权栏，确认这本破书的编纂者是不是在精神极度不稳定的状态下瞎编的。', scores: { A: 2, R: 1, N: 1 } }
    ]
  },
  {
    id: 35,
    stage: 4,
    category: '终极归宿物种契约',
    title: '最后一题：当生活的大船已经不可挽回地驶离原定航道，你最希望此刻趴在你身旁的是：',
    systemNote: '【终审盖印：准备生成终身物种裁决书，点击即刻生效】',
    options: [
      { id: 'A', intensity: 1, label: '一个忠诚、温热、眼里满是信任的家伙，每天准时催我起床，把我牢牢锚定在正常世界里。', scores: { C: 2, S: 2, X: -1 } },
      { id: 'B', intensity: 2, label: '一个独立自洽、互不打扰的生灵，在屋子另一个角落安静待着，谁也不用强行讨好谁。', scores: { I: 2, C: 1 } },
      { id: 'C', intensity: 3, label: '一个精力无限的活力永动机，用没心没肺的疯跑和喧闹，把我生活里的苍白和沉闷撞得粉碎。', scores: { V: 2, E: 1, X: 1 } },
      { id: 'D', intensity: 4, label: '一个精神状态明显比我还超前数个纪元的魔性生物，每天只会咧嘴傻笑，让我觉得天塌下来也就是个屁。', scores: { A: 2, X: 2, N: 2, R: 1 } }
    ]
  }
];

// 兼容别名导出
export const MOCK_QUESTIONS = FORMAL_QUESTIONS;

export const MOCK_RESULTS: Record<'naiwa' | 'golden_retriever', QuizResult> = {
  naiwa: {
    id: 'naiwa',
    caseId: 'SPECIMEN #NW-8804-EXT',
    matchRate: '97.8%',
    targetName: '奶蛙',
    subtitle: '超现实高维黄化幼蛙 · 二创叛逆精神同化体',
    categoryBadge: '【警报：已排除全部常规碳基动物】',
    badgeType: 'danger',
    imageUrl: '/characters/naiwa.png',
    imageAlt: '低多边形风格奶蛙全身大图',
    systemVerdict: '系统综合鉴定：在现有已知的 428 种常规家养哺乳动物中，没有任何一种能够安全承受你当前的精神状态与生活作息。若强行匹配常规猫狗，极易造成宠物单方面抑郁、无故脱毛或过早看破红尘。\n\n依照《非常规生物收容与精神互补条例》第七款，系统已紧急越权调用低多边形高维数据库，指派不可名状之二创叛逆造物——「奶蛙」接管你的人生。',
    detailedAnalysis: [
      '1. 二创叛逆与可爱污染：该生灵脱胎于互联网高频解构浪潮，天生携带强逆反与精神抗内耗力场。当你在深夜遭遇现实暴击或精神内耗时，它会顶着标志性的死鱼眼与微妙笑容，以彻底失控的呆萌姿态强行瓦解你的严肃防线。',
      '2. 极低生活维护门槛：无需每日清晨风雨无阻下楼遛弯，更无拆家打翻花瓶之虞。其主要生命维持能量来自短视频狂欢、冰红茶以及高浓度冲浪玩梗。在遭遇现实不可调和的矛盾时，它将为你执行终极策略——以极其荒谬的神情面对一切。',
      '3. 宿命级双向同频：根据测试指标显示，你与该生物在「抽象浓度」、「逆反指数」与「精神自洽」上契合度高达 97.8%，你们注定将在同一个屋檐下把生活过成一部充满黑色幽默的荒诞短剧。'
    ],
    metrics: [
      { label: '陪伴需求', subLabel: 'Companion', value: 72, note: '“高维依恋接通，死鱼眼二十四小时无死角对你进行精神护航。”' },
      { label: '活动能量', subLabel: 'Energy', value: 24, note: '“两个人加起来凑不出一千步，床垫是你们共同誓死捍卫的阵地。”' },
      { label: '独立倾向', subLabel: 'Independence', value: 78, note: '“骨头极硬且自成闭环宇宙，任何带有说教的指令当场反弹。”' },
      { label: '环境敏感度', subLabel: 'Sensitivity', value: 85, note: '“现实噪音已然过载，唯有纯粹二创荒谬实体能以毒攻毒抚平焦虑。”' },
      { label: '照护耐受', subLabel: 'Maintenance', value: 28, note: '“极简主义照料者的天赐良配，连清理都可以靠意念一键忽略。”' },
      { label: '空间承载', subLabel: 'Space', value: 35, note: '“纵向垂直空间利用大师，趴在最高处俯瞰你两室一厅的微缩江山。”' },
      { label: '存在感偏好', subLabel: 'Presence', value: 65, note: '“魔性气场全天候笼罩，即便闭上眼睛，也能感受到那股不可言说的凝视。”' },
      { label: '新奇接受度', subLabel: 'Novelty', value: 96, note: '“对常规事物严重审美疲劳，唯有不可名状的离谱形态能让你两眼放光。”' },
    ],
    stampText: '【绝密收容 · 强制绑缚】',
    stampType: 'danger',
    coexistenceAdvice: '⚠️ 饲养警示：切勿试图用传统世俗价值观对它进行说教，那会加速它的逆反神经反射；建议在玄关常备外卖炸鸡，遇到困难请大声呼喊它的名字。',
    confidentialLevel: 'CL-4 绝密级精神档案 · 禁止在严肃长辈面前展示'
  },

  golden_retriever: {
    id: 'golden_retriever',
    caseId: 'STANDARD #GR-0104-PUB',
    matchRate: '92.4%',
    targetName: '金毛寻回犬',
    subtitle: '高配合度全天候阳光哺乳类伴侣犬',
    categoryBadge: '【合格：标准碳基优秀伴侣】',
    badgeType: 'normal',
    imageUrl: '/characters/golden_retriever.png',
    imageAlt: '低多边形风格金毛犬全身大图',
    systemVerdict: '系统综合鉴定：恭喜你，你的作息曲线与精神健全度奇迹般地抵御住了测试后半段的全部降智诱导。你拥有极强的社会化自律能力、规律的物理运动习惯，以及对真实生命沉甸甸的托底耐心。\n\n金毛寻回犬是经过系统 35 维变量全矩阵测算后，与你现实生活方式最相融的阳光情绪锚点。',
    detailedAnalysis: [
      '1. 规律作息强行锁定：你具备接纳大体型生命与高频次毛发清洁的胸怀。它每天早晚雷打不动的运动需求，对你而言并非消耗负担，而是将你从封闭室内强行拽入清晨阳光与晚风中的救赎契机。',
      '2. 纯粹而澎湃的情感反馈：它毫无保留的信赖与每一次下班开门时的摇尾飞扑，能够百分百抵消你在外部现实世界中所遭受的所有冷漠与委屈。',
      '3. 健康责任自洽：你拥有将一段长达十余年契约善始善终的成熟心智，你们的共处将成为文明人类与忠诚生灵之间最典范的生活契约。'
    ],
    metrics: [
      { label: '陪伴需求', subLabel: 'Companion', value: 92, note: '“推门一瞬间必须扑倒，哪怕只是下楼拿快递也像生离死别。”' },
      { label: '活动能量', subLabel: 'Energy', value: 88, note: '“脑子还没完成审批，肉体已经冲出门了，双方都不知道今天要跑去哪。”' },
      { label: '独立倾向', subLabel: 'Independence', value: 28, note: '“理论上有边界，实际半小时没动静就会去确认对方还活着。”' },
      { label: '环境敏感度', subLabel: 'Sensitivity', value: 32, note: '“钝感力场强行阻断焦虑，哪怕外面电闪雷鸣，在屋里依然稳如老狗。”' },
      { label: '照护耐受', subLabel: 'Maintenance', value: 94, note: '“具备令系统惊叹的托底耐心，满屋飞毛如金黄雪花般优雅扫起。”' },
      { label: '空间承载', subLabel: 'Space', value: 82, note: '“空间容积率极为宽裕，哪怕再塞进一个大体格实体也毫不逼仄。”' },
      { label: '存在感偏好', subLabel: 'Presence', value: 90, note: '“房间里绝不能冷清，脚步声、打呼声与深情注视全天候拉满。”' },
      { label: '新奇接受度', subLabel: 'Novelty', value: 25, note: '“老牌经典绝不出错，千百年文明驯化的模范伴侣最得你心。”' },
    ],
    stampText: '【合规准养 · 正式批复】',
    stampType: 'normal',
    coexistenceAdvice: '💡 饲养建议：请购置一台工业级吸尘器与结实飞盘；每天至少给予它 45 分钟的草坪狂奔时间，它将回馈你一整个充满金黄暖意的宇宙。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 可堂堂正正发朋友圈'
  }
};
